// extracted by mini-css-extract-plugin
export default {"rightJustifiedContainer":"BranchLogicManager_rightJustifiedContainer__3ZkQt","marginBottom":"BranchLogicManager_marginBottom__qj59u"};